"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ShadowScrollbars = void 0;
var _domCss = _interopRequireDefault(require("dom-css"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../");
var _shadowScrollbarsModule = _interopRequireDefault(require("./shadowScrollbars.module.scss"));
var _excluded = ["style", "shadowColour", "direction", "loading", "useIn", "fireWindowScrollEvents"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ShadowScrollbars = exports.ShadowScrollbars = /*#__PURE__*/function (_Component) {
  function ShadowScrollbars() {
    var _this;
    _classCallCheck(this, ShadowScrollbars);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ShadowScrollbars, [].concat(args));
    _defineProperty(_this, "shadow", {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    });
    _defineProperty(_this, "topShadow", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "bottomShadow", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "leftShadow", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "rightShadow", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "scrollbars", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "handleUpdate", function (values) {
      var shadowTopOpacity = _this.getShadowTopOpacity(values.scrollTop);
      var shadowLeftOpacity = _this.getShadowLeftOpacity(values.scrollLeft);
      var bottomScrollTop = _this.getBottomScrollTop(values);
      var rightScrollLeft = _this.getRightScrollLeft(values);
      var shadowBottomOpacity = _this.getShadowBottomOpacity(bottomScrollTop, values.scrollTop);
      var shadowRightOpacity = _this.getShadowRightOpacity(rightScrollLeft, values.scrollLeft);

      /* istanbul ignore else */
      if (shadowTopOpacity !== _this.shadow.top) {
        _this.shadow.top = shadowTopOpacity;
      }
      /* istanbul ignore else */
      if (shadowBottomOpacity !== _this.shadow.bottom) {
        _this.shadow.bottom = shadowBottomOpacity;
      }
      /* istanbul ignore else */
      if (shadowLeftOpacity !== _this.shadow.left) {
        _this.shadow.left = shadowLeftOpacity;
      }
      /* istanbul ignore else */
      if (shadowRightOpacity !== _this.shadow.right) {
        _this.shadow.right = shadowRightOpacity;
      }
      (0, _domCss["default"])(_this.topShadow.current, {
        opacity: shadowTopOpacity
      });
      (0, _domCss["default"])(_this.bottomShadow.current, {
        opacity: shadowBottomOpacity
      });
      (0, _domCss["default"])(_this.leftShadow.current, {
        opacity: shadowLeftOpacity
      });
      (0, _domCss["default"])(_this.rightShadow.current, {
        opacity: shadowRightOpacity
      });
    });
    return _this;
  }
  _inherits(ShadowScrollbars, _Component);
  return _createClass(ShadowScrollbars, [{
    key: "scrollTop",
    value: function scrollTop() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.scrollbars.current.scrollTop(top);
    }
  }, {
    key: "getShadowTopOpacity",
    value: function getShadowTopOpacity(scrollTop) {
      return 1 / 20 * Math.min(scrollTop, 20);
    }
  }, {
    key: "getShadowLeftOpacity",
    value: function getShadowLeftOpacity(scrollLeft) {
      return 1 / 20 * Math.min(scrollLeft, 20);
    }
  }, {
    key: "getBottomScrollTop",
    value: function getBottomScrollTop(values) {
      return values.scrollHeight - values.clientHeight;
    }
  }, {
    key: "getRightScrollLeft",
    value: function getRightScrollLeft(values) {
      return values.scrollWidth - values.clientWidth;
    }
  }, {
    key: "getShadowBottomOpacity",
    value: function getShadowBottomOpacity(bottomScrollTop, scrollTop) {
      return 1 / 20 * (bottomScrollTop - Math.max(scrollTop, bottomScrollTop - 20));
    }
  }, {
    key: "getShadowRightOpacity",
    value: function getShadowRightOpacity(rightScrollLeft, scrollLeft) {
      return 1 / 20 * (rightScrollLeft - Math.max(scrollLeft, rightScrollLeft - 20));
    }
  }, {
    key: "getShadowColour",
    value: function getShadowColour() {
      return this.props.shadowColour;
    }
  }, {
    key: "getGradientTo",
    value: function getGradientTo(position) {
      switch (position) {
        case "top":
          return "bottom";
        case "bottom":
          return "top";
        case "left":
          return "right";
        default:
          return "left";
      }
    }
  }, {
    key: "getRef",
    value: function getRef(position) {
      return this["".concat(position, "Shadow")];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        style = _this$props.style,
        shadowColour = _this$props.shadowColour,
        direction = _this$props.direction,
        loading = _this$props.loading,
        useIn = _this$props.useIn,
        fireWindowScrollEvents = _this$props.fireWindowScrollEvents,
        props = _objectWithoutProperties(_this$props, _excluded);
      var containerStyle = _objectSpread(_objectSpread({}, style), {}, {
        position: "relative"
      });
      var Shadow = function Shadow(_ref) {
        var position = _ref.position;
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this2.getRef(position),
          className: _shadowScrollbarsModule["default"]["".concat(position, "Shadow")],
          style: {
            background: "linear-gradient(to ".concat(_this2.getGradientTo(position), ", ").concat(_this2.getShadowColour(), " 0%, rgba(255, 255, 255, 0) 100%)"),
            opacity: _this2.shadow[position]
          }
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: containerStyle
      }, /*#__PURE__*/_react["default"].createElement(_.Scrollbars, _extends({
        ref: this.scrollbars,
        fireWindowScrollEvents: fireWindowScrollEvents,
        onUpdate: this.handleUpdate,
        className: _shadowScrollbarsModule["default"].customScrollbar
      }, props)), /*#__PURE__*/_react["default"].createElement(Shadow, {
        position: "top"
      }), /*#__PURE__*/_react["default"].createElement(Shadow, {
        position: "bottom"
      }), /*#__PURE__*/_react["default"].createElement(Shadow, {
        position: "left"
      }), /*#__PURE__*/_react["default"].createElement(Shadow, {
        position: "right"
      }));
    }
  }]);
}(_react.Component);
ShadowScrollbars.propTypes = {
  style: _propTypes["default"].object,
  shadowColour: _propTypes["default"].string,
  fireWindowScrollEvents: _propTypes["default"].bool
};
ShadowScrollbars.defaultProps = {
  shadowColour: "rgba(0, 0, 0, 0.1)",
  fireWindowScrollEvents: true
};
var _default = exports["default"] = ShadowScrollbars;